<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Telegram-бот Foody
    </template>

    <p class="!mb-2">
      Чем полезен:
    </p>

    <ul class="dashed">
      <li>Отслеживает питание через фото, голос и&nbsp;текст.</li>
      <li>Отправляет персональные рекомендации от&nbsp;AI-нутрициолога.</li>
      <li>Анализирует рацион и&nbsp;даёт детальные PDF-отчеты.</li>
      <li>Ведёт статистику КБЖУ с&nbsp;учётом индивидуальных потребностей.</li>
      <li>Отправляет ежедневные отчёты с&nbsp;AI-советами.</li>
    </ul>

    <template #action>
      <BasicButton color="green" title="Понятно" @click="close" />
    </template>
  </CustomModalWindow>
</template>
